module.exports = [{
      plugin: require('../plugins/indexed-content-plugin/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby-plugin-google-tagmanager@5.18.0-react19.1_gatsby@5.18.0-react19.1_@swc+core@1.15_18cec7131d081a240b845f3d9d9e7020/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-TCJBD6M","includeInDevelopment":true,"defaultDataLayer":null,"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/.pnpm/gatsby@5.18.0-react19.1_@swc+core@1.15.17_@swc+helpers@0.5.19__babel-eslint@10.1.0_esli_b0b1279b8f2849ad8f354aa3f86cc066/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
